import * as types from './types';

export const closeMainMenu = () => ({ type: types.CLOSE_MAIN_MENU });

export const openMainMenu = () => ({ type: types.OPEN_MAIN_MENU });



// WEBPACK FOOTER //
// ./src/actions/mainMenu/mainMenuActions.js